import { render } from "./PantryListView.vue?vue&type=template&id=5d1304d9&ts=true"
import script from "./PantryListView.vue?vue&type=script&lang=ts"
export * from "./PantryListView.vue?vue&type=script&lang=ts"

import "./PantryListView.vue?vue&type=style&index=0&id=5d1304d9&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__